import React, { useEffect, useState } from "react";
import { api, errorMessage } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { fmtDateTime } from "../../lib/constants";
import { toast } from "sonner";

export default function AdminAuditLog() {
  const [list, setList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/audit-log");
        setList(data);
      } catch (e) { toast.error(errorMessage(e)); }
    })();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Audit Log</h1>
        <p className="mt-1 text-sm text-slate-400">Timestamped record of significant actions.</p>
      </div>
      <Card className="border-slate-800 bg-slate-900">
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800 hover:bg-transparent">
              <TableHead className="text-slate-400">Timestamp</TableHead>
              <TableHead className="text-slate-400">Action</TableHead>
              <TableHead className="text-slate-400">User</TableHead>
              <TableHead className="text-slate-400">Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.map((l) => (
              <TableRow key={l.audit_id} className="border-slate-800 hover:bg-slate-800/40" data-testid={`audit-${l.audit_id}`}>
                <TableCell className="text-slate-300 text-sm">{fmtDateTime(l.created_at)}</TableCell>
                <TableCell className="text-slate-100 text-sm font-medium">{l.action}</TableCell>
                <TableCell className="text-slate-400 text-xs font-mono">{(l.user_id || "").slice(0, 8)}</TableCell>
                <TableCell className="text-slate-400 text-xs font-mono">{JSON.stringify(l.details || {})}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
